export default __webpack_public_path__ + "static/media/homeabout3.96569609.jpg";